import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  warehouse: '',
  total_pages: 0,
  total_results: 0  
};
export const useWarehouseFetch = id => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use Employee fetch")
  console.log(id)
  useEffect(()=>{
    console.log("binne use Employee fetch se useEffect")
    const fetchWarehouse = async()=>{
      try {
        setLoading(true);
        setError(false);
       setTrigger(false)
        const warehouse = await API.fetchWarehouse(id,accessToken)
       
        console.log(warehouse)
        setState({  
          ...warehouse.warehouse
          
        }
        )

        setLoading(false)

      } catch (error) {
        console.log(error)
        setError(true);
      }
    }
    fetchWarehouse()
  },[id,trigger]);

return{state,loading,error,setLoading,setTrigger};


};
